import type { SortChangedDetail, ZprSortDropdownCustomEvent } from '@zappar/zpr-ui-components-stencil';
import { SortOption } from '../types';

import { ZprSortDropdown } from '@zpr-stencil';


export interface SortDropdownProps {
  /** Current sort option */
  sortBy: SortOption;
  /** Callback for sort option changes */
  onSortChange: (sortBy: SortOption) => void;
  dropdownZIndex?: string;
  theme?: string;
}

export const SortDropdown: React.FC<SortDropdownProps> = ({ sortBy, onSortChange, theme, dropdownZIndex }) => {
  return (
    <ZprSortDropdown
      onSortchanged={(event: ZprSortDropdownCustomEvent<SortChangedDetail>) => onSortChange(event.detail.sortValue as SortOption)}
      preset="media-library"
      sortValue={sortBy}
      theme={theme}
      dropdownZIndex={dropdownZIndex}
    />
  );
};